import { skipTracingStore } from "../store";

export function updateBatchName(batchName: string) {
  skipTracingStore.batchName = batchName;
}
